export default __webpack_public_path__ + "static/media/veh-5.6ecfe9d9.png";